module.exports = __webpack_public_path__ + "static/img/1045@2x.3c48fd51.png";